var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShopping(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.722,
    height: 32.013,
    viewBox: "0 0 28.722 32.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_188",
    "data-name": "Trac\\xE9 188",
    d: "M15.183,2a4,4,0,0,1,4,4v4h-8V6A4,4,0,0,1,15.183,2Zm6,8V6a6,6,0,1,0-12,0v4H5.9a3,3,0,0,0-2.967,2.554L.878,26.27a5,5,0,0,0,4.946,5.742H24.541a5,5,0,0,0,4.948-5.742L27.432,12.559A3,3,0,0,0,24.467,10Zm-2,2v3a1,1,0,0,0,2,0V12h3.279a1,1,0,0,1,.988.852L27.51,26.565a3,3,0,0,1-2.967,3.447H5.824a3,3,0,0,1-2.967-3.447L4.913,12.857A1,1,0,0,1,5.9,12H9.181v3a1,1,0,1,0,2,0V12Z",
    transform: "translate(-0.822)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopping);
export default __webpack_public_path__ + "static/media/icon-shopping.7e69938e4f551915ab76a0bc778a2250.svg";
export { ForwardRef as ReactComponent };